const startsWithHttps = (url) => /^https:/.test(url);
const startsWithHttp = (url) => /^http:/.test(url);
const getHost = (url) => !url ? url : !startsWithHttps(url) && !startsWithHttp(url) ? new URL(`http://${url}`).host : new URL(url).host;
const getUrlForDisplay = (url) => url.replace(/^https?:\/\//, "");
export {
  getHost,
  getUrlForDisplay,
  startsWithHttp,
  startsWithHttps
};
//# sourceMappingURL=utils.js.map
